import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'

const NewPositionsModal = (
    {
        newDepartament,
        modalIsOpen,
        closeModal,
        handleSubmit,
        handleChange,
        validateForm,
        textBtn
    }
) => {
    const customStyles = {
        content: {
            width: "60%",
        }
    }

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Añadir cargo"
            className="custom-modal"
            ariaHideApp={false}
        >
            <span className="custom-modal__close close-btn" onClick={closeModal}><CloseBtn /></span>
            <h4 className="custom-modal__title">Añadir nuevo departamento</h4>
            <Form onSubmit={handleSubmit} className="products__form">
                <Form.Group controlId="product-name">
                    <Form.Label className="form__labels">Nombre <RequieredInputs/> </Form.Label>
                    <Form.Control className="user-input name"
                        type="text"
                        name="nombre"
                        value={newDepartament.nombre}
                        onChange={handleChange}
                        placeholder="Nombre del departamento"
                    />
                </Form.Group>
                <button 
                    className="btn save create"
                    onClick={handleSubmit}
                    disabled={!validateForm()}
                    onSubmit={handleSubmit}
                >
                    {textBtn}
                </button>
            </Form>
        </ReactModal>
    )
}
ReactModal.setAppElement('#root')
export default NewPositionsModal